// import { Filesystem, Directory } from '@capacitor/filesystem';

// // 标准化的 D3 基础路径（相对于 ExternalStorage）
// export const D3_BASE_PATH = 'Download/d3';

// // 检查 upgrade 目录是否存在
// export async function checkUpgradeDirExists(): Promise<boolean> {
//   const full = `${D3_BASE_PATH}/upgrade`;
//   try {
//     await Filesystem.readdir({ path: full, directory: Directory.ExternalStorage });
//     return true;
//   } catch (e: any) {
//     console.error('检测 upgrade 目录不存在', { full, error: e?.message || String(e) });
//     return false;
//   }
// }
// export async function checkLogsDirExists(): Promise<boolean> {
//   const full = `${D3_BASE_PATH}/logs`;
//   try {
//     await Filesystem.readdir({ path: full, directory: Directory.ExternalStorage });
//     return true;
//   } catch (e: any) {
//     console.error('检测 logs 目录不存在', { full, error: e?.message || String(e) });
//     return false;
//   }
// }
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import {
  checkAndroidD3LogsDirExists,
  checkAndroidD3UpgradeDirExists,
} from '@/capacitor/permissions/android-storage-permission';

// 根据不同的平台
export const D3_BASE_PATH = (() => {
  if (Capacitor.getPlatform() === 'android') {
    return 'Download/d3';
  } else if (Capacitor.getPlatform() === 'ios') {
    return 'd3';
  }
  return 'd3'; // Web 或其他平台的默认值
})();
// 平台特定的基础路径和目录
export const getPlatformConfig = () => {
  const platform = Capacitor.getPlatform();
  return {
    basePath: D3_BASE_PATH, // 直接使用 D3_BASE_PATH
    directory: platform === 'android' ? Directory.ExternalStorage : Directory.Documents
  };
};

// 检查 upgrade 目录是否存在
export async function checkUpgradeDirExists(): Promise<boolean> {
  if (Capacitor.getPlatform() === 'android') {
    return await checkAndroidD3UpgradeDirExists();
  }

  const { basePath, directory } = getPlatformConfig();
  const full = `${basePath}/upgrade`;

  try {
    await Filesystem.readdir({ path: full, directory });
    return true;
  } catch (e: any) {
    console.error('检测 upgrade 目录不存在', {
      platform: Capacitor.getPlatform(),
      full,
      directory,
      error: e?.message || String(e),
    });
    return false;
  }
}

// 检查 logs 目录是否存在
export async function checkLogsDirExists(): Promise<boolean> {
  if (Capacitor.getPlatform() === 'android') {
    return await checkAndroidD3LogsDirExists();
  }

  const { basePath, directory } = getPlatformConfig();
  const full = `${basePath}/logs`;

  try {
    await Filesystem.readdir({ path: full, directory });
    return true;
  } catch (e: any) {
    console.error('检测 logs 目录不存在', { 
      platform: Capacitor.getPlatform(),
      full, 
      directory,
      error: e?.message || String(e) 
    });
    return false;
  }
}

// 检查 assets 目录是否存在
export async function checkAssetsDirExists(): Promise<boolean> {
  const { basePath, directory } = getPlatformConfig();
  const full = `${basePath}/assets`;
  
  try {
    await Filesystem.readdir({ path: full, directory });
    return true;
  } catch (e: any) {
    console.error('检测 assets 目录不存在', { 
      platform: Capacitor.getPlatform(),
      full, 
      directory,
      error: e?.message || String(e) 
    });
    return false;
  }
}